'use strict';
import {isWebBuild} from '../../config/constants';
import {pingServer, pingServerError, pingServerSuccess} from '../actions';


/**
 * @typedef {Object} ServerStatusState
 * @property {Boolean} isOnline
 * @property {Boolean} isFetching
 */

/** @type {ServerStatusState} */
const initialState = {
  // if this is a web build, initialize as true since we are expected to be online normally.
  // if this is a cordova build, we may be offline initially.
  isOnline: isWebBuild(),
  isFetching: false,
};

/**
 *
 * @param {ServerStatusState} state
 * @param {ReduxAction} action
 * @return {ServerStatusState}
 */
export function serverStatus(state = initialState, action) {
  switch (action.type) {
    case pingServer.TYPE:
      return {
        ...state,
        isFetching: true,
      };
    case pingServerSuccess.TYPE:
      return {
        ...state,
        isFetching: false,
        isOnline: true,
      };
    case pingServerError.TYPE:
      return {
        ...state,
        isFetching: false,
        isOnline: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/js/settings/reducers/serverStatusReducers.js